require('./blocks/best-brands.less');
require('./blocks/catalog.less');
require('./blocks/letters.less');
require('./blocks/filter/filter');
require('./blocks/brands/brands');
require('./blocks/brand-item.less');
require('./blocks/pagination.less');
require('./blocks/soc-marks.less');
require('./blocks/soc-marks');



// WEBPACK FOOTER //
// ./brands.js